import React from "react";
import "../Styles/PatientSafety.css";
import patientSafetyData from "../contents/PatientSafety";
import safetyImage from "../Images/Patient-Safety.jpeg";

const PatientSafety = () => {
  return (
    <div className="patient-safety">
      <h1>{patientSafetyData.title}</h1>
      <h2>{patientSafetyData.subtitle}</h2>

      <div className="patient-safety-image">
        <img
          src={safetyImage}
          alt="Patient safety and sterilization protocols"
          loading="lazy"
        />
      </div>
      <p>{patientSafetyData.intro}</p>

      <ol>
        {patientSafetyData.safetyMeasures.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ol>

      <h2>{patientSafetyData.convenienceTitle}</h2>

      <ol>
        {patientSafetyData.conveniencePoints.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ol>
    </div>
  );
};

export default PatientSafety;
